var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.processComplete
    ? _c("payment-single", {
        attrs: {
          "booking-id": _vm.bookingId,
          "payment-id": _vm.firstPaymentId,
        },
      })
    : _c(
        "div",
        { staticClass: "container dashboard-block" },
        [_c("pickstar-loading", { staticClass: "m-t-lg" })],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }